/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of PurchaseOrdersClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfGetPurchaseOrderHeadersResponse,
  SuccessResponse_1OfPurchaseOrderHeader,
  SuccessResponse_1OfRAG,
  SuccessResponse_1OfIEnumerable_1OfPurchaseOrderRag,
  CreatePurchaseOrderHeaderRequest,
  PutPurchaseOrderHeaderRequest,
  SuccessResponse_1OfBoolean,
  AdjustPurchaseOrderRequestDto,
  SuccessResponse_1OfOrderTypesResponse,
  AddItemsInPurchaseOrderRequest,
  CalculateDiscrepanciesLine,
  BeginCreditReqRequest,
  GenericCreditRequestResponse,
  SendCreditReqRequest,
  SuccessResponse_1OfIEnumerable_1OfCreditRequestRag,
  SuccessResponse_1OfIEnumerable_1OfCreditRequestValue,
  SuccessResponse_1OfIEnumerable_1OfCreditRequestsValuesResponse,
  SuccessResponse_1OfReturnToVendorHeaders,
  ReturnToVendorRequest,
  SuccessResponse_1OfPostReturnToVendorResponse,
  SuccessResponse_1OfDateTime,
  PostSuppliersRequest,
  SuccessResponse_1OfFranchiseOrderTypes,
  SuccessResponse_1OfSupplierResponse,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockPurchaseOrderHeaders: any[] = [
  {
    id: 1,
    orderNumber: 'GR-2026-001',
    ewsOrderNumber: 'EWS-2026-001',
    customisedOrderNumber: 'CUST-001',
    storeNumber: '001',
    orderType: 'Fresh & Daily',
    deliveryDate: '2026-01-03T09:00:00',
    invoiceNumber: 'INV-2026-001',
    note: 'Received in good condition',
    packingSlipNumber: 'PS-2026-001',
    acceptedDate: '2026-01-03T09:15:00',
    isReceived: true,
    receivedBy: 'John Smith',
    supplierName: 'Fresh Foods Ltd',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2025-12-30T10:00:00',
    receivingDate: '2026-01-03T09:15:00',
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-2025-001',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 101,
        purchaseOrderHeaderId: 1,
        lineNumber: '1',
        itemNumber: 'SKU-MILK-001',
        itemDescription: 'Whole Milk 2L',
        expectedUom: 'CASE',
        expectedQuantity: 10,
        sequenceNumber: 1,
        receivedUom: 'CASE',
        receivedQuantity: 10,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 24.50,
        insertedByUser: false,
        orderedQuantity: 10,
        batches: [
          {
            id: 1001,
            purchaseOrderLineId: 101,
            batchNumber: 'BATCH-MILK-20260103',
            batchQuantity: 10,
            originalBatchQuantity: 10,
            expirationDate: '2026-01-10',
          },
        ],
      },
      {
        id: 102,
        purchaseOrderHeaderId: 1,
        lineNumber: '2',
        itemNumber: 'SKU-BREAD-001',
        itemDescription: 'White Bread Loaf',
        expectedUom: 'CASE',
        expectedQuantity: 15,
        sequenceNumber: 2,
        receivedUom: 'CASE',
        receivedQuantity: 15,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 18.00,
        insertedByUser: false,
        orderedQuantity: 15,
      },
      {
        id: 103,
        purchaseOrderHeaderId: 1,
        lineNumber: '3',
        itemNumber: 'SKU-COFFEE-001',
        itemDescription: 'Premium Coffee Beans 1kg',
        expectedUom: 'CASE',
        expectedQuantity: 5,
        sequenceNumber: 3,
        receivedUom: 'CASE',
        receivedQuantity: 5,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 85.00,
        insertedByUser: false,
        orderedQuantity: 5,
      },
    ],
  },
  {
    id: 2,
    orderNumber: 'GR-2026-002',
    ewsOrderNumber: 'EWS-2026-002',
    customisedOrderNumber: 'CUST-002',
    storeNumber: '001',
    orderType: 'Ambient',
    deliveryDate: '2026-01-04T10:00:00',
    invoiceNumber: null,
    note: null,
    packingSlipNumber: null,
    acceptedDate: null,
    isReceived: false,
    receivedBy: null,
    supplierName: 'Ambient Supplies Co',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2026-01-02T14:00:00',
    receivingDate: null,
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-2025-002',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 201,
        purchaseOrderHeaderId: 2,
        lineNumber: '1',
        itemNumber: 'SKU-SUGAR-001',
        itemDescription: 'Granulated Sugar 1kg',
        expectedUom: 'CASE',
        expectedQuantity: 20,
        sequenceNumber: 1,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 12.50,
        insertedByUser: false,
        orderedQuantity: 20,
      },
      {
        id: 202,
        purchaseOrderHeaderId: 2,
        lineNumber: '2',
        itemNumber: 'SKU-PASTA-001',
        itemDescription: 'Penne Pasta 500g',
        expectedUom: 'CASE',
        expectedQuantity: 12,
        sequenceNumber: 2,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 15.60,
        insertedByUser: false,
        orderedQuantity: 12,
      },
    ],
  },
  {
    id: 3,
    orderNumber: 'GR-2026-003',
    ewsOrderNumber: 'EWS-2026-003',
    customisedOrderNumber: 'CUST-003',
    storeNumber: '001',
    orderType: 'Frozen',
    deliveryDate: '2026-01-05T11:00:00',
    invoiceNumber: null,
    note: null,
    packingSlipNumber: null,
    acceptedDate: null,
    isReceived: false,
    receivedBy: null,
    supplierName: 'Ice Cold Distributors',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2026-01-03T09:30:00',
    receivingDate: null,
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-2025-003',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 301,
        purchaseOrderHeaderId: 3,
        lineNumber: '1',
        itemNumber: 'SKU-ICECREAM-001',
        itemDescription: 'Vanilla Ice Cream 1L',
        expectedUom: 'CASE',
        expectedQuantity: 8,
        sequenceNumber: 1,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 42.00,
        insertedByUser: false,
        orderedQuantity: 8,
      },
      {
        id: 302,
        purchaseOrderHeaderId: 3,
        lineNumber: '2',
        itemNumber: 'SKU-FRIES-001',
        itemDescription: 'French Fries 1kg',
        expectedUom: 'CASE',
        expectedQuantity: 25,
        sequenceNumber: 2,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 22.50,
        insertedByUser: false,
        orderedQuantity: 25,
      },
    ],
  },
  {
    id: 4,
    orderNumber: 'GR-2026-004',
    ewsOrderNumber: 'EWS-2026-004',
    customisedOrderNumber: 'CUST-004',
    storeNumber: '001',
    orderType: 'Fresh & Daily',
    deliveryDate: '2026-01-06T09:00:00',
    invoiceNumber: null,
    note: null,
    packingSlipNumber: null,
    acceptedDate: null,
    isReceived: false,
    receivedBy: null,
    supplierName: 'Fresh Foods Ltd',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2026-01-04T11:00:00',
    receivingDate: null,
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-2025-004',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 401,
        purchaseOrderHeaderId: 4,
        lineNumber: '1',
        itemNumber: 'SKU-MILK-001',
        itemDescription: 'Whole Milk 2L',
        expectedUom: 'CASE',
        expectedQuantity: 12,
        sequenceNumber: 1,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 24.50,
        insertedByUser: false,
        orderedQuantity: 12,
      },
      {
        id: 402,
        purchaseOrderHeaderId: 4,
        lineNumber: '2',
        itemNumber: 'SKU-EGGS-001',
        itemDescription: 'Free Range Eggs 12pk',
        expectedUom: 'CASE',
        expectedQuantity: 18,
        sequenceNumber: 2,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 35.40,
        insertedByUser: false,
        orderedQuantity: 18,
      },
    ],
  },
  {
    id: 5,
    orderNumber: 'GR-2026-005',
    ewsOrderNumber: 'EWS-2026-005',
    customisedOrderNumber: 'CUST-005',
    storeNumber: '001',
    orderType: 'Fresh & Daily',
    deliveryDate: '2026-01-02T08:30:00',
    invoiceNumber: 'INV-2026-005',
    note: 'Some items damaged - credit request raised',
    packingSlipNumber: 'PS-2025-005',
    acceptedDate: '2026-01-02T08:45:00',
    isReceived: true,
    receivedBy: 'Sarah Jones',
    supplierName: 'Fresh Foods Ltd',
    creditRequestExpected: true,
    creditRequestStatus: 1,
    creditRequestSentDateTime: '2026-01-02T10:00:00',
    creditRequestNumber: 'CR-2026-001',
    addedDate: '2025-12-30T15:00:00',
    receivingDate: '2026-01-02T08:45:00',
    showReason: true,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-2025-005',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 501,
        purchaseOrderHeaderId: 5,
        lineNumber: '1',
        itemNumber: 'SKU-BREAD-001',
        itemDescription: 'White Bread Loaf',
        expectedUom: 'CASE',
        expectedQuantity: 20,
        sequenceNumber: 1,
        receivedUom: 'CASE',
        receivedQuantity: 18,
        note: '2 cases damaged in transit',
        isSelected: true,
        creditedAmount: 36.00,
        creditedUom: 'CASE',
        creditedQuantity: 2,
        reasonForCreditRequest: 'Damaged packaging',
        hasDiscrepancy: true,
        unitCostPrice: 18.00,
        insertedByUser: false,
        orderedQuantity: 20,
        photos: [
          {
            fileName: 'damaged-bread-001.jpg',
            fileData: 'base64encodedimagedata...',
          },
        ],
      },
      {
        id: 502,
        purchaseOrderHeaderId: 5,
        lineNumber: '2',
        itemNumber: 'SKU-MILK-001',
        itemDescription: 'Whole Milk 2L',
        expectedUom: 'CASE',
        expectedQuantity: 15,
        sequenceNumber: 2,
        receivedUom: 'CASE',
        receivedQuantity: 15,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 24.50,
        insertedByUser: false,
        orderedQuantity: 15,
        batches: [
          {
            id: 5001,
            purchaseOrderLineId: 502,
            batchNumber: 'BATCH-MILK-20260102',
            batchQuantity: 15,
            originalBatchQuantity: 15,
            expirationDate: '2026-01-09',
          },
        ],
      },
    ],
  },
  {
    id: 6,
    orderNumber: 'GR-2026-006',
    ewsOrderNumber: 'EWS-2026-006',
    customisedOrderNumber: 'CUST-006',
    storeNumber: '002',
    orderType: 'Alcohol',
    deliveryDate: '2026-01-04T13:00:00',
    invoiceNumber: 'INV-2026-006',
    note: 'All items received in good condition',
    packingSlipNumber: 'PS-2025-006',
    acceptedDate: '2026-01-04T13:20:00',
    isReceived: true,
    receivedBy: 'Mike Johnson',
    supplierName: 'Premium Beverages Ltd',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2026-01-02T10:00:00',
    receivingDate: '2026-01-04T13:20:00',
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-2025-006',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 601,
        purchaseOrderHeaderId: 6,
        lineNumber: '1',
        itemNumber: 'SKU-WINE-001',
        itemDescription: 'Red Wine Merlot 750ml',
        expectedUom: 'CASE',
        expectedQuantity: 6,
        sequenceNumber: 1,
        receivedUom: 'CASE',
        receivedQuantity: 6,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 125.00,
        insertedByUser: false,
        orderedQuantity: 6,
      },
      {
        id: 602,
        purchaseOrderHeaderId: 6,
        lineNumber: '2',
        itemNumber: 'SKU-BEER-001',
        itemDescription: 'Lager Beer 330ml 24pk',
        expectedUom: 'CASE',
        expectedQuantity: 10,
        sequenceNumber: 2,
        receivedUom: 'CASE',
        receivedQuantity: 10,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 38.50,
        insertedByUser: false,
        orderedQuantity: 10,
      },
    ],
  },
  {
    id: 7,
    orderNumber: 'GR-2026-007',
    ewsOrderNumber: 'EWS-2026-007',
    customisedOrderNumber: 'CUST-007',
    storeNumber: '003',
    orderType: 'Fresh & Daily',
    deliveryDate: '2026-01-07T08:00:00',
    invoiceNumber: null,
    note: null,
    packingSlipNumber: null,
    acceptedDate: null,
    isReceived: false,
    receivedBy: null,
    supplierName: 'Fresh Foods Ltd',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2026-01-05T16:00:00',
    receivingDate: null,
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-2026-007',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 701,
        purchaseOrderHeaderId: 7,
        lineNumber: '1',
        itemNumber: 'SKU-MILK-001',
        itemDescription: 'Whole Milk 2L',
        expectedUom: 'CASE',
        expectedQuantity: 18,
        sequenceNumber: 1,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 24.50,
        insertedByUser: false,
        orderedQuantity: 18,
      },
      {
        id: 702,
        purchaseOrderHeaderId: 7,
        lineNumber: '2',
        itemNumber: 'SKU-BREAD-001',
        itemDescription: 'White Bread Loaf',
        expectedUom: 'CASE',
        expectedQuantity: 25,
        sequenceNumber: 2,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 18.00,
        insertedByUser: false,
        orderedQuantity: 25,
      },
      {
        id: 703,
        purchaseOrderHeaderId: 7,
        lineNumber: '3',
        itemNumber: 'SKU-YOGURT-001',
        itemDescription: 'Greek Yogurt 500g',
        expectedUom: 'CASE',
        expectedQuantity: 12,
        sequenceNumber: 3,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 28.80,
        insertedByUser: false,
        orderedQuantity: 12,
      },
    ],
  },
  {
    id: 8,
    orderNumber: 'GR-2026-008',
    ewsOrderNumber: 'EWS-2026-008',
    customisedOrderNumber: 'CUST-008',
    storeNumber: '001',
    orderType: 'Non-Food',
    deliveryDate: '2026-01-08T14:00:00',
    invoiceNumber: null,
    note: null,
    packingSlipNumber: null,
    acceptedDate: null,
    isReceived: false,
    receivedBy: null,
    supplierName: 'Cleaning Supplies Direct',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2026-01-06T11:00:00',
    receivingDate: null,
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-2026-008',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 801,
        purchaseOrderHeaderId: 8,
        lineNumber: '1',
        itemNumber: 'SKU-CLEANER-001',
        itemDescription: 'Multi-Purpose Cleaner 5L',
        expectedUom: 'CASE',
        expectedQuantity: 4,
        sequenceNumber: 1,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 32.00,
        insertedByUser: false,
        orderedQuantity: 4,
      },
      {
        id: 802,
        purchaseOrderHeaderId: 8,
        lineNumber: '2',
        itemNumber: 'SKU-PAPER-001',
        itemDescription: 'Paper Towels Roll 12pk',
        expectedUom: 'CASE',
        expectedQuantity: 8,
        sequenceNumber: 2,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 24.00,
        insertedByUser: false,
        orderedQuantity: 8,
      },
    ],
  },
  {
    id: 9,
    orderNumber: 'GR-2026-009',
    ewsOrderNumber: 'EWS-2026-009',
    customisedOrderNumber: 'CUST-009',
    storeNumber: '004',
    orderType: 'Fresh & Daily',
    deliveryDate: '2026-01-03T09:30:00',
    invoiceNumber: 'INV-2026-009',
    note: 'All received - good quality',
    packingSlipNumber: 'PS-2025-009',
    acceptedDate: '2026-01-03T09:45:00',
    isReceived: true,
    receivedBy: 'Jane Williams',
    supplierName: 'Fresh Foods Ltd',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2025-12-31T12:00:00',
    receivingDate: '2026-01-03T09:45:00',
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-2025-009',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 901,
        purchaseOrderHeaderId: 9,
        lineNumber: '1',
        itemNumber: 'SKU-MILK-001',
        itemDescription: 'Whole Milk 2L',
        expectedUom: 'CASE',
        expectedQuantity: 14,
        sequenceNumber: 1,
        receivedUom: 'CASE',
        receivedQuantity: 14,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 24.50,
        insertedByUser: false,
        orderedQuantity: 14,
        batches: [
          {
            id: 9001,
            purchaseOrderLineId: 901,
            batchNumber: 'BATCH-MILK-20260103-A',
            batchQuantity: 14,
            originalBatchQuantity: 14,
            expirationDate: '2026-01-10',
          },
        ],
      },
      {
        id: 902,
        purchaseOrderHeaderId: 9,
        lineNumber: '2',
        itemNumber: 'SKU-COFFEE-001',
        itemDescription: 'Premium Coffee Beans 1kg',
        expectedUom: 'CASE',
        expectedQuantity: 8,
        sequenceNumber: 2,
        receivedUom: 'CASE',
        receivedQuantity: 8,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 85.00,
        insertedByUser: false,
        orderedQuantity: 8,
      },
    ],
  },
  {
    id: 10,
    orderNumber: 'GR-2026-010',
    ewsOrderNumber: 'EWS-2026-010',
    customisedOrderNumber: 'CUST-010',
    storeNumber: '004',
    orderType: 'Ambient',
    deliveryDate: '2026-01-05T10:00:00',
    invoiceNumber: null,
    note: null,
    packingSlipNumber: null,
    acceptedDate: null,
    isReceived: false,
    receivedBy: null,
    supplierName: 'Ambient Supplies Co',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2026-01-03T14:30:00',
    receivingDate: null,
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-2026-010',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 1001,
        purchaseOrderHeaderId: 10,
        lineNumber: '1',
        itemNumber: 'SKU-SUGAR-001',
        itemDescription: 'Granulated Sugar 1kg',
        expectedUom: 'CASE',
        expectedQuantity: 15,
        sequenceNumber: 1,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 12.50,
        insertedByUser: false,
        orderedQuantity: 15,
      },
    ],
  },
  {
    id: 11,
    orderNumber: 'GR-2026-011',
    ewsOrderNumber: 'EWS-2026-011',
    customisedOrderNumber: 'CUST-011',
    storeNumber: '004',
    orderType: 'Frozen',
    deliveryDate: '2026-01-06T11:30:00',
    invoiceNumber: null,
    note: null,
    packingSlipNumber: null,
    acceptedDate: null,
    isReceived: false,
    receivedBy: null,
    supplierName: 'Ice Cold Distributors',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2026-01-04T09:00:00',
    receivingDate: null,
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-2026-011',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 1101,
        purchaseOrderHeaderId: 11,
        lineNumber: '1',
        itemNumber: 'SKU-ICECREAM-001',
        itemDescription: 'Vanilla Ice Cream 1L',
        expectedUom: 'CASE',
        expectedQuantity: 6,
        sequenceNumber: 1,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 42.00,
        insertedByUser: false,
        orderedQuantity: 6,
      },
    ],
  },
  {
    id: 12,
    orderNumber: 'GR-2026-012',
    ewsOrderNumber: 'EWS-2026-012',
    customisedOrderNumber: 'CUST-012',
    storeNumber: '005',
    orderType: 'Fresh & Daily',
    deliveryDate: '2026-01-04T08:00:00',
    invoiceNumber: 'INV-2026-012',
    note: 'Quick delivery, all good',
    packingSlipNumber: 'PS-2025-012',
    acceptedDate: '2026-01-04T08:15:00',
    isReceived: true,
    receivedBy: 'Tom Anderson',
    supplierName: 'Fresh Foods Ltd',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2026-01-02T16:00:00',
    receivingDate: '2026-01-04T08:15:00',
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-2025-012',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 1201,
        purchaseOrderHeaderId: 12,
        lineNumber: '1',
        itemNumber: 'SKU-BREAD-001',
        itemDescription: 'White Bread Loaf',
        expectedUom: 'CASE',
        expectedQuantity: 12,
        sequenceNumber: 1,
        receivedUom: 'CASE',
        receivedQuantity: 12,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 18.00,
        insertedByUser: false,
        orderedQuantity: 12,
      },
      {
        id: 1202,
        purchaseOrderHeaderId: 12,
        lineNumber: '2',
        itemNumber: 'SKU-MILK-001',
        itemDescription: 'Whole Milk 2L',
        expectedUom: 'CASE',
        expectedQuantity: 10,
        sequenceNumber: 2,
        receivedUom: 'CASE',
        receivedQuantity: 10,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 24.50,
        insertedByUser: false,
        orderedQuantity: 10,
        batches: [
          {
            id: 12001,
            purchaseOrderLineId: 1202,
            batchNumber: 'BATCH-MILK-20260104',
            batchQuantity: 10,
            originalBatchQuantity: 10,
            expirationDate: '2026-01-11',
          },
        ],
      },
    ],
  },
  {
    id: 13,
    orderNumber: 'GR-2026-013',
    ewsOrderNumber: 'EWS-2026-013',
    customisedOrderNumber: 'CUST-013',
    storeNumber: '005',
    orderType: 'Fresh & Daily',
    deliveryDate: '2026-01-07T09:00:00',
    invoiceNumber: null,
    note: null,
    packingSlipNumber: null,
    acceptedDate: null,
    isReceived: false,
    receivedBy: null,
    supplierName: 'Fresh Foods Ltd',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2026-01-05T10:00:00',
    receivingDate: null,
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-2026-013',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 1301,
        purchaseOrderHeaderId: 13,
        lineNumber: '1',
        itemNumber: 'SKU-COFFEE-001',
        itemDescription: 'Premium Coffee Beans 1kg',
        expectedUom: 'CASE',
        expectedQuantity: 6,
        sequenceNumber: 1,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 85.00,
        insertedByUser: false,
        orderedQuantity: 6,
      },
      {
        id: 1302,
        purchaseOrderHeaderId: 13,
        lineNumber: '2',
        itemNumber: 'SKU-SUGAR-001',
        itemDescription: 'Granulated Sugar 1kg',
        expectedUom: 'CASE',
        expectedQuantity: 18,
        sequenceNumber: 2,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 12.50,
        insertedByUser: false,
        orderedQuantity: 18,
      },
    ],
  },
  // ---- Vapiano Purchase Orders ----
  {
    id: 101,
    orderNumber: 'VAP-2026-001',
    ewsOrderNumber: 'EWS-VAP-001',
    customisedOrderNumber: null,
    storeNumber: 'VAP001',
    orderType: 'Fresh & Daily',
    deliveryDate: '2026-01-06T07:00:00',
    invoiceNumber: 'INV-IFI-2026-001',
    note: 'Left at goods entrance',
    packingSlipNumber: 'PS-IFI-001',
    acceptedDate: '2026-01-06T07:30:00',
    isReceived: true,
    receivedBy: 'Marco Rossi',
    supplierName: 'Italian Fresh Imports',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2026-01-03T14:00:00',
    receivingDate: '2026-01-06T07:30:00',
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-VAP-001',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 10101,
        purchaseOrderHeaderId: 101,
        lineNumber: '1',
        itemNumber: 'VAP-GUANCIALE-001',
        itemDescription: 'Guanciale (Cured Pork Cheek) 2kg',
        expectedUom: 'EACH',
        expectedQuantity: 6,
        sequenceNumber: 1,
        receivedUom: 'EACH',
        receivedQuantity: 6,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 28.50,
        insertedByUser: false,
        orderedQuantity: 6,
      },
      {
        id: 10102,
        purchaseOrderHeaderId: 101,
        lineNumber: '2',
        itemNumber: 'VAP-PECORINO-001',
        itemDescription: 'Pecorino Romano DOP 5kg wheel',
        expectedUom: 'EACH',
        expectedQuantity: 2,
        sequenceNumber: 2,
        receivedUom: 'EACH',
        receivedQuantity: 2,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 65.00,
        insertedByUser: false,
        orderedQuantity: 2,
      },
      {
        id: 10103,
        purchaseOrderHeaderId: 101,
        lineNumber: '3',
        itemNumber: 'VAP-MOZZ-001',
        itemDescription: 'Fior di Latte Mozzarella 1kg',
        expectedUom: 'CASE',
        expectedQuantity: 10,
        sequenceNumber: 3,
        receivedUom: 'CASE',
        receivedQuantity: 10,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 12.80,
        insertedByUser: false,
        orderedQuantity: 10,
      },
      {
        id: 10104,
        purchaseOrderHeaderId: 101,
        lineNumber: '4',
        itemNumber: 'VAP-PRAWNS-001',
        itemDescription: 'King Prawns (Raw, Peeled) 1kg',
        expectedUom: 'CASE',
        expectedQuantity: 5,
        sequenceNumber: 4,
        receivedUom: 'CASE',
        receivedQuantity: 5,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 18.00,
        insertedByUser: false,
        orderedQuantity: 5,
      },
    ],
  },
  {
    id: 102,
    orderNumber: 'VAP-2026-002',
    ewsOrderNumber: 'EWS-VAP-002',
    customisedOrderNumber: null,
    storeNumber: 'VAP001',
    orderType: 'Dry & Ambient',
    deliveryDate: '2026-01-07T08:00:00',
    invoiceNumber: null,
    note: null,
    packingSlipNumber: null,
    acceptedDate: null,
    isReceived: false,
    receivedBy: null,
    supplierName: 'Mediterranean Pantry Wholesale',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2026-01-04T16:00:00',
    receivingDate: null,
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-VAP-002',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 10201,
        purchaseOrderHeaderId: 102,
        lineNumber: '1',
        itemNumber: 'VAP-FLOUR-001',
        itemDescription: '00 Flour (Caputo) 25kg',
        expectedUom: 'BAG',
        expectedQuantity: 4,
        sequenceNumber: 1,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 18.50,
        insertedByUser: false,
        orderedQuantity: 4,
      },
      {
        id: 10202,
        purchaseOrderHeaderId: 102,
        lineNumber: '2',
        itemNumber: 'VAP-SEMOLINA-001',
        itemDescription: 'Semolina Flour (Fine) 25kg',
        expectedUom: 'BAG',
        expectedQuantity: 2,
        sequenceNumber: 2,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 22.00,
        insertedByUser: false,
        orderedQuantity: 2,
      },
      {
        id: 10203,
        purchaseOrderHeaderId: 102,
        lineNumber: '3',
        itemNumber: 'VAP-TOMATO-001',
        itemDescription: 'San Marzano Tomatoes DOP 2.5kg',
        expectedUom: 'CASE',
        expectedQuantity: 12,
        sequenceNumber: 3,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 4.80,
        insertedByUser: false,
        orderedQuantity: 12,
      },
      {
        id: 10204,
        purchaseOrderHeaderId: 102,
        lineNumber: '4',
        itemNumber: 'VAP-OLIVE-001',
        itemDescription: 'Extra Virgin Olive Oil 5L',
        expectedUom: 'EACH',
        expectedQuantity: 3,
        sequenceNumber: 4,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 24.00,
        insertedByUser: false,
        orderedQuantity: 3,
      },
    ],
  },
  {
    id: 103,
    orderNumber: 'VAP-2026-003',
    ewsOrderNumber: 'EWS-VAP-003',
    customisedOrderNumber: null,
    storeNumber: 'VAP001',
    orderType: 'Beverages',
    deliveryDate: '2026-01-08T09:00:00',
    invoiceNumber: null,
    note: null,
    packingSlipNumber: null,
    acceptedDate: null,
    isReceived: false,
    receivedBy: null,
    supplierName: 'Veneto Wines & Spirits',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2026-01-05T10:00:00',
    receivingDate: null,
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-VAP-003',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 10301,
        purchaseOrderHeaderId: 103,
        lineNumber: '1',
        itemNumber: 'VAP-PROSECCO-001',
        itemDescription: 'Prosecco DOC 750ml',
        expectedUom: 'CASE',
        expectedQuantity: 8,
        sequenceNumber: 1,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 6.50,
        insertedByUser: false,
        orderedQuantity: 8,
      },
      {
        id: 10302,
        purchaseOrderHeaderId: 103,
        lineNumber: '2',
        itemNumber: 'VAP-APEROL-001',
        itemDescription: 'Aperol 700ml',
        expectedUom: 'EACH',
        expectedQuantity: 6,
        sequenceNumber: 2,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 14.50,
        insertedByUser: false,
        orderedQuantity: 6,
      },
    ],
  },
  // ---- Five Guys Purchase Orders ----
  {
    id: 201,
    orderNumber: 'FG-2026-001',
    ewsOrderNumber: 'EWS-FG-001',
    customisedOrderNumber: null,
    storeNumber: 'FG001',
    orderType: 'Fresh & Daily',
    deliveryDate: '2026-01-06T06:00:00',
    invoiceNumber: 'INV-PB-2026-001',
    note: 'Temperature checked on arrival',
    packingSlipNumber: 'PS-PB-001',
    acceptedDate: '2026-01-06T06:20:00',
    isReceived: true,
    receivedBy: 'Dave Martinez',
    supplierName: 'Premium Beef Suppliers UK',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2026-01-03T11:00:00',
    receivingDate: '2026-01-06T06:20:00',
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-FG-001',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 20101,
        purchaseOrderHeaderId: 201,
        lineNumber: '1',
        itemNumber: 'FG-BEEF-001',
        itemDescription: 'Fresh Ground Beef Patties 4oz x48',
        expectedUom: 'CASE',
        expectedQuantity: 10,
        sequenceNumber: 1,
        receivedUom: 'CASE',
        receivedQuantity: 10,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 68.00,
        insertedByUser: false,
        orderedQuantity: 10,
      },
      {
        id: 20102,
        purchaseOrderHeaderId: 201,
        lineNumber: '2',
        itemNumber: 'FG-BACON-001',
        itemDescription: 'Smoked Back Bacon 2.5kg',
        expectedUom: 'CASE',
        expectedQuantity: 6,
        sequenceNumber: 2,
        receivedUom: 'CASE',
        receivedQuantity: 6,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 14.50,
        insertedByUser: false,
        orderedQuantity: 6,
      },
      {
        id: 20103,
        purchaseOrderHeaderId: 201,
        lineNumber: '3',
        itemNumber: 'FG-HOTDOG-001',
        itemDescription: 'All-Beef Hot Dog Franks x48',
        expectedUom: 'CASE',
        expectedQuantity: 4,
        sequenceNumber: 3,
        receivedUom: 'CASE',
        receivedQuantity: 4,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 24.00,
        insertedByUser: false,
        orderedQuantity: 4,
      },
    ],
  },
  {
    id: 202,
    orderNumber: 'FG-2026-002',
    ewsOrderNumber: 'EWS-FG-002',
    customisedOrderNumber: null,
    storeNumber: 'FG001',
    orderType: 'Fresh Produce',
    deliveryDate: '2026-01-06T07:00:00',
    invoiceNumber: null,
    note: null,
    packingSlipNumber: null,
    acceptedDate: null,
    isReceived: false,
    receivedBy: null,
    supplierName: 'Farm Fresh Produce Ltd',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2026-01-04T09:00:00',
    receivingDate: null,
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-FG-002',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 20201,
        purchaseOrderHeaderId: 202,
        lineNumber: '1',
        itemNumber: 'FG-POTATO-001',
        itemDescription: 'Fresh Potatoes (Maris Piper) 25kg',
        expectedUom: 'BAG',
        expectedQuantity: 15,
        sequenceNumber: 1,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 8.50,
        insertedByUser: false,
        orderedQuantity: 15,
      },
      {
        id: 20202,
        purchaseOrderHeaderId: 202,
        lineNumber: '2',
        itemNumber: 'FG-LETTUCE-001',
        itemDescription: 'Iceberg Lettuce (whole heads) x12',
        expectedUom: 'CASE',
        expectedQuantity: 8,
        sequenceNumber: 2,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 9.60,
        insertedByUser: false,
        orderedQuantity: 8,
      },
      {
        id: 20203,
        purchaseOrderHeaderId: 202,
        lineNumber: '3',
        itemNumber: 'FG-TOMATO-001',
        itemDescription: 'Fresh Tomatoes (Vine) 5kg',
        expectedUom: 'CASE',
        expectedQuantity: 6,
        sequenceNumber: 3,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 7.50,
        insertedByUser: false,
        orderedQuantity: 6,
      },
      {
        id: 20204,
        purchaseOrderHeaderId: 202,
        lineNumber: '4',
        itemNumber: 'FG-ONION-001',
        itemDescription: 'White Onions 10kg',
        expectedUom: 'BAG',
        expectedQuantity: 4,
        sequenceNumber: 4,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 5.00,
        insertedByUser: false,
        orderedQuantity: 4,
      },
      {
        id: 20205,
        purchaseOrderHeaderId: 202,
        lineNumber: '5',
        itemNumber: 'FG-JALAPENO-001',
        itemDescription: 'Fresh Jalapeños 2kg',
        expectedUom: 'CASE',
        expectedQuantity: 5,
        sequenceNumber: 5,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 6.80,
        insertedByUser: false,
        orderedQuantity: 5,
      },
    ],
  },
  {
    id: 203,
    orderNumber: 'FG-2026-003',
    ewsOrderNumber: 'EWS-FG-003',
    customisedOrderNumber: null,
    storeNumber: 'FG001',
    orderType: 'Supplies',
    deliveryDate: '2026-01-07T08:00:00',
    invoiceNumber: null,
    note: null,
    packingSlipNumber: null,
    acceptedDate: null,
    isReceived: false,
    receivedBy: null,
    supplierName: 'Kitchen Essentials Co',
    creditRequestExpected: false,
    creditRequestStatus: 0,
    addedDate: '2026-01-05T13:00:00',
    receivingDate: null,
    showReason: false,
    returnToVendorStatus: 0,
    erpOrderNumber: 'ERP-FG-003',
    externallyCreatedOrder: false,
    deliveryDateUpdated: false,
    purchaseOrderLines: [
      {
        id: 20301,
        purchaseOrderHeaderId: 203,
        lineNumber: '1',
        itemNumber: 'FG-PEANUT-OIL-001',
        itemDescription: '100% Refined Peanut Oil 20L',
        expectedUom: 'EACH',
        expectedQuantity: 5,
        sequenceNumber: 1,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 32.00,
        insertedByUser: false,
        orderedQuantity: 5,
      },
      {
        id: 20302,
        purchaseOrderHeaderId: 203,
        lineNumber: '2',
        itemNumber: 'FG-BUNS-001',
        itemDescription: 'Sesame Seed Burger Buns x60',
        expectedUom: 'CASE',
        expectedQuantity: 8,
        sequenceNumber: 2,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 18.00,
        insertedByUser: false,
        orderedQuantity: 8,
      },
      {
        id: 20303,
        purchaseOrderHeaderId: 203,
        lineNumber: '3',
        itemNumber: 'FG-CAJUN-001',
        itemDescription: 'Five Guys Cajun Seasoning 2kg',
        expectedUom: 'EACH',
        expectedQuantity: 3,
        sequenceNumber: 3,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 8.50,
        insertedByUser: false,
        orderedQuantity: 3,
      },
      {
        id: 20304,
        purchaseOrderHeaderId: 203,
        lineNumber: '4',
        itemNumber: 'FG-PEANUTS-001',
        itemDescription: 'Roasted Peanuts (In-Shell) 10kg',
        expectedUom: 'BAG',
        expectedQuantity: 5,
        sequenceNumber: 4,
        receivedUom: null,
        receivedQuantity: null,
        note: '',
        isSelected: false,
        creditedAmount: 0,
        hasDiscrepancy: false,
        unitCostPrice: 12.00,
        insertedByUser: false,
        orderedQuantity: 5,
      },
    ],
  },
];

/* ---- Mocked Client Implementation ---- */

import { IPurchaseOrdersClient } from '../../interfaces';
export class PurchaseOrdersClientMocked implements IPurchaseOrdersClient {
  constructor(baseUrl?: string) {
    console.log('[PurchaseOrdersClientMocked] Initialized with', mockPurchaseOrderHeaders.length, 'mock purchase orders across stores:', 
      Array.from(new Set(mockPurchaseOrderHeaders.map(po => po.storeNumber))).join(', '));
  }

  async purchaseordersGET(
    store?: string,
    id?: string,
    orderNumber?: string,
    packingSlip?: string,
    orderType?: string,
    supplier?: string,
    from?: string,
    to?: string,
    deliveryDate?: string,
    received?: boolean,
    sort?: string,
    direction?: string,
    skip?: number,
    take?: number,
    cancelToken?: CancelToken
  ): Promise<SuccessResponse_1OfGetPurchaseOrderHeadersResponse> {
    await delay();
    console.log('[PurchaseOrdersClientMocked] purchaseordersGET called with filters:', {
      store, orderNumber, orderType, supplier, received, from, to
    });
    
    let filtered = [...mockPurchaseOrderHeaders];
    
    // Apply filters
    if (store) {
      const storeFiltered = filtered.filter((po) => po.storeNumber === store);
      // In mocked environment, if store filter returns nothing, show all data for testing
      filtered = storeFiltered.length > 0 ? storeFiltered : filtered;
    }
    if (orderNumber) filtered = filtered.filter((po) => po.orderNumber?.toLowerCase().includes(orderNumber.toLowerCase()));
    if (packingSlip) filtered = filtered.filter((po) => po.packingSlipNumber?.toLowerCase().includes(packingSlip.toLowerCase()));
    if (orderType) filtered = filtered.filter((po) => po.orderType === orderType);
    if (supplier) filtered = filtered.filter((po) => po.supplierName?.toLowerCase().includes(supplier.toLowerCase()));
    if (received !== undefined) filtered = filtered.filter((po) => po.isReceived === received);
    
    // Date range filters
    if (from) {
      const fromDate = new Date(from);
      filtered = filtered.filter((po) => new Date(po.deliveryDate) >= fromDate);
    }
    if (to) {
      const toDate = new Date(to);
      filtered = filtered.filter((po) => new Date(po.deliveryDate) <= toDate);
    }
    
    // Sorting
    if (sort) {
      const sortField = sort as keyof typeof mockPurchaseOrderHeaders[0];
      filtered.sort((a, b) => {
        const aVal = a[sortField];
        const bVal = b[sortField];
        if (aVal === bVal) return 0;
        const comparison = aVal > bVal ? 1 : -1;
        return direction === 'desc' ? -comparison : comparison;
      });
    } else {
      // Default sort by delivery date descending
      filtered.sort((a, b) => new Date(b.deliveryDate).getTime() - new Date(a.deliveryDate).getTime());
    }
    
    // Pagination
    const start = skip || 0;
    const end = start + (take || 10);
    const paginatedResults = filtered.slice(start, end);
    
    console.log('[PurchaseOrdersClientMocked] Returning', paginatedResults.length, 'of', filtered.length, 'purchase orders');
    
    return successResponse({
      purchaseOrderHeaders: paginatedResults,
      purchaseOrderHeadersCount: filtered.length,
    }) as SuccessResponse_1OfGetPurchaseOrderHeadersResponse;
  }

  async purchaseordersPOST(body?: CreatePurchaseOrderHeaderRequest, cancelToken?: CancelToken): Promise<number> {
    await delay();
    const newId = mockPurchaseOrderHeaders.length + 1;
    const newOrder = {
      id: newId,
      orderNumber: `GR-2025-00${newId}`,
      ewsOrderNumber: `EWS-2025-00${newId}`,
      storeNumber: body?.storeNumber || '001',
      orderType: body?.orderType || 'Fresh & Daily',
      supplierName: body?.supplierName || 'New Supplier',
      deliveryDate: body?.deliveryDate || new Date().toISOString(),
      isReceived: false,
      creditRequestExpected: false,
      creditRequestStatus: 0,
      addedDate: new Date().toISOString(),
      showReason: false,
      returnToVendorStatus: 0,
      externallyCreatedOrder: false,
      deliveryDateUpdated: false,
      purchaseOrderLines: [],
    };
    mockPurchaseOrderHeaders.push(newOrder);
    console.log('[PurchaseOrdersClientMocked] Created new purchase order:', newId);
    return newId;
  }

  async purchaseordersGET2(purchaseOrderHeaderId: number, itemNumberOrDescription?: string, lineNumber?: string, sort?: string, direction?: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfPurchaseOrderHeader> {
    await delay();
    console.log('[PurchaseOrdersClientMocked] purchaseordersGET2 called for ID:', purchaseOrderHeaderId);
    
    let po = mockPurchaseOrderHeaders.find((p) => p.id === purchaseOrderHeaderId);
    if (!po) {
      console.warn('[PurchaseOrdersClientMocked] Purchase order not found:', purchaseOrderHeaderId);
      po = mockPurchaseOrderHeaders[0];
    }
    
    let lines = po.purchaseOrderLines || [];
    
    // Apply filters
    if (itemNumberOrDescription) {
      lines = lines.filter((line: any) =>
        line.itemNumber?.toLowerCase().includes(itemNumberOrDescription.toLowerCase()) ||
        line.itemDescription?.toLowerCase().includes(itemNumberOrDescription.toLowerCase())
      );
    }
    if (lineNumber) {
      lines = lines.filter((line: any) => line.lineNumber === lineNumber);
    }
    
    // Sorting
    if (sort) {
      lines.sort((a: any, b: any) => {
        const aVal = a[sort];
        const bVal = b[sort];
        if (aVal === bVal) return 0;
        const comparison = aVal > bVal ? 1 : -1;
        return direction === 'desc' ? -comparison : comparison;
      });
    }
    
    return successResponse({
      ...po,
      purchaseOrderLines: lines,
    }) as SuccessResponse_1OfPurchaseOrderHeader;
  }

  async purchaseordersPUT(purchaseOrderHeaderId: number, body?: PutPurchaseOrderHeaderRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const po = mockPurchaseOrderHeaders.find((p) => p.id === purchaseOrderHeaderId);
    if (po && body) {
      Object.assign(po, body);
      console.log('[PurchaseOrdersClientMocked] Updated purchase order:', purchaseOrderHeaderId);
    }
  }

  async approve(purchaseOrderHeaderId: number, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const po = mockPurchaseOrderHeaders.find((p) => p.id === purchaseOrderHeaderId);
    if (po) {
      po.isReceived = true;
      po.receivedBy = 'System User';
      po.receivingDate = new Date().toISOString();
      po.acceptedDate = new Date().toISOString();
      console.log('[PurchaseOrdersClientMocked] Approved purchase order:', purchaseOrderHeaderId);
    }
  }

  async send(purchaseOrderHeaderId: number, cancelToken?: CancelToken): Promise<void> {
    await delay();
    console.log('[PurchaseOrdersClientMocked] Sent purchase order:', purchaseOrderHeaderId);
  }

  async purchaseordersDELETE(purchaseOrderHeaderId: number, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const index = mockPurchaseOrderHeaders.findIndex((p) => p.id === purchaseOrderHeaderId);
    if (index > -1) {
      mockPurchaseOrderHeaders.splice(index, 1);
      console.log('[PurchaseOrdersClientMocked] Deleted purchase order:', purchaseOrderHeaderId);
    }
  }

  async purchaseordersPATCH(purchaseOrderHeaderId: number, body?: PutPurchaseOrderHeaderRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const po = mockPurchaseOrderHeaders.find((p) => p.id === purchaseOrderHeaderId);
    if (po && body) {
      Object.assign(po, body);
      console.log('[PurchaseOrdersClientMocked] Patched purchase order:', purchaseOrderHeaderId);
    }
  }

  async rag(cancelToken?: CancelToken): Promise<SuccessResponse_1OfRAG> {
    await delay();
    const unreceived = mockPurchaseOrderHeaders.filter(po => !po.isReceived).length;
    const withCreditRequests = mockPurchaseOrderHeaders.filter(po => po.creditRequestExpected).length;
    const received = mockPurchaseOrderHeaders.filter(po => po.isReceived).length;
    
    return successResponse({ 
      red: withCreditRequests, 
      amber: unreceived, 
      green: received 
    }) as SuccessResponse_1OfRAG;
  }

  async ragdata(status: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfIEnumerable_1OfPurchaseOrderRag> {
    await delay();
    const data = mockPurchaseOrderHeaders.map(po => ({
      dateOfReceipt: po.receivingDate,
      store: po.storeNumber,
      orderNo: po.orderNumber,
      type: po.orderType,
    }));
    return successResponse(data) as SuccessResponse_1OfIEnumerable_1OfPurchaseOrderRag;
  }

  async import5(body?: CreatePurchaseOrderHeaderRequest[], cancelToken?: CancelToken): Promise<void> {
    await delay();
    console.log('[PurchaseOrdersClientMocked] Import called with', body?.length, 'orders');
  }

  async search(
    storeNumber: string,
    search?: string,
    skip?: number,
    take?: number,
    supplierNumber?: string,
    cancelToken?: CancelToken
  ): Promise<SuccessResponse_1OfGetPurchaseOrderHeadersResponse> {
    await delay();
    let filtered = mockPurchaseOrderHeaders.filter(po => po.storeNumber === storeNumber);
    
    if (search) {
      filtered = filtered.filter(po => 
        po.orderNumber?.toLowerCase().includes(search.toLowerCase()) ||
        po.supplierName?.toLowerCase().includes(search.toLowerCase())
      );
    }
    
    if (supplierNumber) {
      filtered = filtered.filter(po => po.supplierName?.includes(supplierNumber));
    }
    
    const start = skip || 0;
    const end = start + (take || 10);
    
    return successResponse({
      purchaseOrderHeaders: filtered.slice(start, end),
      purchaseOrderHeadersCount: filtered.length,
    }) as SuccessResponse_1OfGetPurchaseOrderHeadersResponse;
  }

  async copy(purchaseOrderHeaderId: number, cancelToken?: CancelToken): Promise<number> {
    await delay();
    const newId = mockPurchaseOrderHeaders.length + 1;
    const source = mockPurchaseOrderHeaders.find((p) => p.id === purchaseOrderHeaderId);
    if (source) {
      const newOrder = {
        ...source,
        id: newId,
        orderNumber: `GR-2025-00${newId}`,
        ewsOrderNumber: `EWS-2025-00${newId}`,
        isReceived: false,
        receivedBy: null,
        receivingDate: null,
        acceptedDate: null,
        invoiceNumber: null,
        packingSlipNumber: null,
        note: null,
        addedDate: new Date().toISOString(),
        purchaseOrderLines: source.purchaseOrderLines?.map((line: any, idx: number) => ({
          ...line,
          id: newId * 100 + idx + 1,
          purchaseOrderHeaderId: newId,
          receivedQuantity: null,
          receivedUom: null,
          note: '',
          batches: [],
        })),
      };
      mockPurchaseOrderHeaders.push(newOrder);
      console.log('[PurchaseOrdersClientMocked] Copied purchase order:', purchaseOrderHeaderId, 'to', newId);
    }
    return newId;
  }

  // ====== Auto-generated stub methods ======




































    async getbyorderid(purchaseOrderHeaderId?: number | undefined, itemNumberOrDescription?: string | undefined, lineNumber?: string | undefined, sort?: string | undefined, direction?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPurchaseOrderHeader> {
        await delay();
        if (!purchaseOrderHeaderId) {
          return successResponse(mockPurchaseOrderHeaders[0]) as SuccessResponse_1OfPurchaseOrderHeader;
        }
        return this.purchaseordersGET2(purchaseOrderHeaderId, itemNumberOrDescription, lineNumber, sort, direction, cancelToken);
    }

    async many(body?: CreatePurchaseOrderHeaderRequest[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        await delay();
        console.log('[PurchaseOrdersClientMocked] many called with', body?.length, 'orders');
    }

    async isreceivingpurchaseorder(purchaseOrderHeaderId?: number | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfBoolean> {
        await delay();
        const po = mockPurchaseOrderHeaders.find(p => p.id === purchaseOrderHeaderId);
        return successResponse(!po?.isReceived) as SuccessResponse_1OfBoolean;
    }

    async getbyragstatus(status: number, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfPurchaseOrderRag> {
        await delay();
        let filtered = mockPurchaseOrderHeaders;
        
        // Status: 1 = red (credit requests), 2 = amber (unreceived), 3 = green (received)
        if (status === 1) {
          filtered = mockPurchaseOrderHeaders.filter(po => po.creditRequestExpected);
        } else if (status === 2) {
          filtered = mockPurchaseOrderHeaders.filter(po => !po.isReceived);
        } else if (status === 3) {
          filtered = mockPurchaseOrderHeaders.filter(po => po.isReceived);
        }
        
        const data = filtered.map(po => ({
          dateOfReceipt: po.receivingDate,
          store: po.storeNumber,
          orderNo: po.orderNumber,
          type: po.orderType,
        }));
        
        return successResponse(data) as SuccessResponse_1OfIEnumerable_1OfPurchaseOrderRag;
    }

    async adjust(id: number, body?: AdjustPurchaseOrderRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        await delay();
        const po = mockPurchaseOrderHeaders.find(p => p.id === id);
        if (po && body) {
          // Update purchase order lines with adjusted quantities
          console.log('[PurchaseOrdersClientMocked] Adjusted purchase order:', id);
        }
    }

    async getOrderTypes(franchiseName: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfOrderTypesResponse> {
        await delay();
        const orderTypes = ['Fresh & Daily', 'Ambient', 'Frozen', 'Alcohol', 'Non-Food'];
        return successResponse({ name: orderTypes }) as SuccessResponse_1OfOrderTypesResponse;
    }

    async additemsinpurchaseorder(body?: AddItemsInPurchaseOrderRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        throw new Error('Method additemsinpurchaseorder not implemented in mocked client');
    }

    async calculatediscrepancies(storeNumber: string, body?: CalculateDiscrepanciesLine[] | undefined, cancelToken?: CancelToken | undefined): Promise<string[]> {
        throw new Error('Method calculatediscrepancies not implemented in mocked client');
    }

    async begincreditrequest(body?: BeginCreditReqRequest | undefined, cancelToken?: CancelToken | undefined): Promise<GenericCreditRequestResponse> {
        throw new Error('Method begincreditrequest not implemented in mocked client');
    }

    async sendcreditrequest(body?: SendCreditReqRequest | undefined, cancelToken?: CancelToken | undefined): Promise<GenericCreditRequestResponse> {
        throw new Error('Method sendcreditrequest not implemented in mocked client');
    }

    async getcreditrequestcutoff(ewsOrderNumber: string, storeNumber?: string | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        throw new Error('Method getcreditrequestcutoff not implemented in mocked client');
    }

    async getcreditrequeststatusrag(storeNumber?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfRAG> {
        throw new Error('Method getcreditrequeststatusrag not implemented in mocked client');
    }

    async getcreditrequeststatusdatabyrag(status: number, storeNumber?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfCreditRequestRag> {
        throw new Error('Method getcreditrequeststatusdatabyrag not implemented in mocked client');
    }

    async getcreditrequestvaluedata(storeNumber?: string | undefined, showAllStores?: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfCreditRequestValue> {
        throw new Error('Method getcreditrequestvaluedata not implemented in mocked client');
    }

    async allownewreturntovendorrequest(purchaseOrderHeaderId?: number | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        throw new Error('Method allownewreturntovendorrequest not implemented in mocked client');
    }

    async getPurchaseOrdersCreditRequests(purchaseOrderHeaderId: number, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfCreditRequestsValuesResponse> {
        throw new Error('Method getPurchaseOrdersCreditRequests not implemented in mocked client');
    }

    async getreturntovendordetails(returnToVendorId?: number | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfReturnToVendorHeaders> {
        throw new Error('Method getreturntovendordetails not implemented in mocked client');
    }

    async postreturntovendor(body?: ReturnToVendorRequest | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPostReturnToVendorResponse> {
        throw new Error('Method postreturntovendor not implemented in mocked client');
    }

    async sendreturntovendorrequest(body?: SendCreditReqRequest | undefined, cancelToken?: CancelToken | undefined): Promise<GenericCreditRequestResponse> {
        throw new Error('Method sendreturntovendorrequest not implemented in mocked client');
    }

    async getLocalTime(purchaseOrderHeaderId?: number | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfDateTime> {
        throw new Error('Method getLocalTime not implemented in mocked client');
    }

    async saveSuppliers(body?: PostSuppliersRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        throw new Error('Method saveSuppliers not implemented in mocked client');
    }

    async getfranchiseordertypestatus(franchiseName?: string | undefined, orderType?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfFranchiseOrderTypes> {
        throw new Error('Method getfranchiseordertypestatus not implemented in mocked client');
    }

    async getPurchaseOrderSuppliers(franchiseName?: string | undefined, storeNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfSupplierResponse> {
        await delay();
        // Get unique suppliers from mock purchase orders
        const uniqueSuppliers = Array.from(new Set(mockPurchaseOrderHeaders.map(po => po.supplierName)))
          .filter(s => s)
          .map(name => ({ name }));
        
        console.log('[PurchaseOrdersClientMocked] Returning', uniqueSuppliers.length, 'unique suppliers');
        return successResponse({ suppliers: uniqueSuppliers }) as SuccessResponse_1OfSupplierResponse;
    }

}
